import { FilterItem } from './types';

type Module = 'insights' | 'articlevisibility';

interface ModuleFilterConfig {
  available?: FilterItem[][]; // Typo in original code - keeping for compatibility
  other?: FilterItem[][];
}

const MODULE_FILTER_CONFIG: Record<Module, ModuleFilterConfig> = {
  insights: {
    available: [
      [
        { type: 'dateRange' },
        { type: 'dateRangeComparison' },
        { type: 'countries' },
        { type: 'brands' },
        { type: 'marketplaces', cols: 2 },
      ],
      [
        { type: 'categories' },
        { type: 'seasons' },
        { type: 'genders' },
        { type: 'ageGroups' },
        { type: 'fulfillmentMethods' },
        { type: 'sizes' },
        { type: 'colors' },
        { type: 'products' },
      ],
    ],
    other: [[{ type: 'creationDateRange' }, { type: 'benchmark' }]],
  },

  articlevisibility: {
    available: [
      [{ type: 'creationDateRange' }, { type: 'countries' }, { type: 'brands' }, { type: 'marketplaces' }],
      [{ type: 'fulfillmentMethods' }, { type: 'sizes' }, { type: 'colors' }, { type: 'products' }],
    ],
    other: [[{ type: 'categories' }, { type: 'genders' }, { type: 'seasons' }, { type: 'ageGroups' }]],
  },
};

export type { Module, FilterItem };
export { MODULE_FILTER_CONFIG };
